import CreateDataItemRequestModelBase from '../_generated/modelBases/create-data-item-request-model-base';

export default class CreateDataItemRequestModel extends CreateDataItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
